import Completed from './Completed';
import Reviewable from './Reviewable';

export enum ReviewTabType {
  REVIEWABLE = 'reviewable',
  COMPLETED = 'completed',
}

const Tabs = {
  [ReviewTabType.REVIEWABLE]: Reviewable,
  [ReviewTabType.COMPLETED]: Completed,
};

export default Tabs;
